<template>
    <div class="flex -mx-2">
        <div class="px-2">
            <v-editor
                v-bind="$props"
                ref="editor"
                @click="$emit('click')"
                @hover="$emit('hover')"
                @blur="$emit('blur')"
                @focus="$emit('focus')"
            ></v-editor>
        </div>
        <div class="px-2">
            <v-label :id="id" label="Variables"></v-label>
            <table>
                <tbody>
                    <tr v-for="variable in variables" class="py-2">
                        <td class="text-sm py-1 text-gray-700 ">
                            {{ variable.label }}:
                        </td>
                        <td class="py-1 pl-2 text-right">
                            <span class="py-1 px-2 text-sm bg-gray-100 rounded text-gray-900 cursor-pointer" @click="addVariable(variable.name)">%{{ variable.name }}%</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    import Label from './Label';
    import Editor from './WYSIWYG';
    import mixin from './mixin';

    export default {
        components: {
            'v-label': Label,
            'v-editor': Editor
        },
        mixins: [mixin],
        props: {
            variableType: {
                type: String,
                default: 'invoice'
            },
            inputClassName: {
                type: String,
                default() {
                    return this.$spa.css.form.input_full_width + ' min-h-32';
                }
            },
        },
        data() {
            return {
                variables: null
            }
        },
        methods: {
            addVariable(variable)
            {
                if ( this.model === '' ) {
                    this.model = `%${variable}%`;
                } else {
                    this.model += ` %${variable}%`;
                }
                this.$refs.editor.update(this.model);
            },

            setVariables(variables)
            {
                this.variables = [];
                for ( let i = 0; i < variables.length; i++ ) {
                    this.variables.push({
                        name: variables[i],
                        label: this.$t(`form.variables.${variables[i]}`)
                    });
                }
            }
        },
        created() {
            if ( this.variableType == 'invoice' ) {
                this.setVariables([
                    'invoicenumber',
                    'communication',
                    'invoiceamount',
                    'invoiceremainingamount',
                    'bic',
                    'iban',
                    'invoicedate',
                    'duedate',
                    'companyname'
                ]);
            }
            if ( this.variableType == 'credit-note' || this.variableType == 'credit_note' ) {
                this.setVariables([
                    'creditnotenumber',
                    'creditnoteamount',
                    'creditnoteremainingamount',
                    'bic',
                    'iban',
                    'creditnotedate',
                    'companyname'
                ]);
            }
            if ( this.variableType == 'quote' ) {
                this.setVariables([
                    'quotenumber',
                    'quoteamount',
                    'bic',
                    'iban',
                    'quotedate', 
                    'validitydate',
                    'companyname'
                ]);
            }
        }
    }
</script>
